import {
  isRequired,
  isValidUploadedImageSize,
  isValidUploadedImageFormat,
  isNumber,
  isValidLength
} from 'utils/validators';

const validate = values => {
  const errors = {};

  if (values.coverPhoto) {
    if (isRequired(values.coverPhoto.image || '', true)) {
      errors.coverPhoto = 'Cover photo is required';
    } else if (isValidUploadedImageSize(values.coverPhoto || '', true)) {
      errors.coverPhoto = 'Your file exceeded the size limit';
    } else if (isValidUploadedImageFormat(values.coverPhoto || '', true)) {
      errors.coverPhoto = `File could not be uploaded because the format is not supported. Please upload the file with the format png, jpg, jpeg`;
    }
  } else {
    errors.coverPhoto = 'Cover photo is required';
  }

  if (isRequired(values.title || '', true)) {
    errors.title = 'Title is required';
  }

  if (isRequired(values.minParticipants || '', true)) {
    errors.minParticipants = 'Number of participants is required';
  } else if (isNumber(values.minParticipants || '', true)) {
    errors.minParticipants = 'Number of participants can be only number';
  } else if (isValidLength(values.minParticipants || '', 9, true)) {
    errors.minParticipants =
      'Number of participants can be max 9 characters long';
  }

  if (isRequired(values.maxParticipants || '', true)) {
    errors.maxParticipants = 'Number of participants is required';
  } else if (isNumber(values.maxParticipants || '', true)) {
    errors.maxParticipants = 'Number of participants can be only number';
  } else if (isValidLength(values.maxParticipants || '', 9, true)) {
    errors.maxParticipants =
      'Number of participants can be max 9 characters long';
  } else if (
    values.minParticipants &&
    parseInt(values.minParticipants) > parseInt(values.maxParticipants)
  ) {
    errors.maxParticipants =
      'Maximum number can not be less than minimum number of participants';
  }

  if (isRequired(values.startingPoint || '', true)) {
    errors.startingPoint = 'Starting point is required';
  }

  return errors;
};

export default validate;
